var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellicon = function SvgBellicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.085 21a4.083 4.083 0 1 1-8.167 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.436 21H5.564a2.064 2.064 0 0 1-1.46-3.524l.704-.703a3.5 3.5 0 0 0 1.025-2.475v-3.215a8.167 8.167 0 1 1 16.334 0v3.215a3.5 3.5 0 0 0 1.025 2.475l.703.703A2.064 2.064 0 0 1 22.437 21"
  })));
};
export default SvgBellicon;